module.exports = __webpack_public_path__ + "img/default_head.840b4837.jpg";